exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-772805a4]{box-sizing:border-box}@media (min-width:901px){html[data-v-772805a4]{font-size:130%}}@media (min-width:601px) and (max-width:900px){html[data-v-772805a4]{font-size:120%}}@media (max-width:600px){html[data-v-772805a4]{font-size:100%}}@media (max-width:350px){html[data-v-772805a4]{font-size:100%}}[data-v-772805a4],[data-v-772805a4]:after,[data-v-772805a4]:before{box-sizing:inherit}em[data-v-772805a4]{font-style:italic}.list[data-v-772805a4]{padding:1rem}@media (min-width:901px){.list[data-v-772805a4]{float:left;width:50%}}.list .space[data-v-772805a4]{display:inline-block;width:1.2rem;margin-left:.3rem}.list .section[data-v-772805a4]{margin-bottom:1em}.list ul[data-v-772805a4]{margin-bottom:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-772805a4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/List.vue
// module id = 28
// module chunks = 0